<section class="main-section">
  <header class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a
      class="btn btn-link me-3 p-0 d-block d-xl-none"
      data-bs-toggle="offcanvas"
      href="#offcanvasExample"
      role="button"
      aria-controls="offcanvasExample"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 7H21"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M3 12H21"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M3 17H21"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-linecap="round"/></svg></a>
      <h3 class="heading-span">Profile</h3>
    </div>
  </header>
  <div *ngIf="userData.email"
    class="bg-white d-flex justify-content-between align-items-center radius8 mb-3"
  >
    <div
      class="bg-gray d-flex justify-content-between align-items-center radius8 mb-4 w-100"
    >
      <div class="profile-grid-container grid-container radius8">
        <div class="grid-item edit-profile-container">
          <div class="edit-profile-container position-relative profile-icon-width">
            <label class="hoverable" (click)="fileInput.click()" for="fileInput">
            
              <img class="profile-image position-relative"
                [src]="url ? url : '../../../assets/images/profile-icon.svg'"
                alt="profile"
              />
              <span class="edit-icon" [class.hidden]="uploadCompleted">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mb-md-3 my-0 ml2 custom-margin-edit-icon"
                >
                  <path
                    d="M8.84 2.4008L3.36667 8.19413C3.16 8.41413 2.96 8.84746 2.92 9.14746L2.67334 11.3075C2.58667 12.0875 3.14667 12.6208 3.92 12.4875L6.06667 12.1208C6.36667 12.0675 6.78667 11.8475 6.99334 11.6208L12.4667 5.82746C13.4133 4.82746 13.84 3.68746 12.3667 2.29413C10.9 0.914129 9.78667 1.4008 8.84 2.4008Z"
                    stroke="#fff"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.92667 3.36719C8.21333 5.20719 9.70667 6.61385 11.56 6.80052"
                    stroke="#fff"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="edit-icon close-icon" [class.hidden]="!uploadCompleted">
                <svg width="11" height="11" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 1L1 11M1 1L11 11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </label>
            <input hidden type="file" #fileInput (change)="onFileSelected($event)" accept="image/*"/>
          </div>
        </div>
        <div class="grid-item">
          <div class="row">
            <div class="col-md-12">
          <form [formGroup]="profileForm" >
            <div class="row text-start">
              <div class="col-sm-12 mb-0">
                <span class="form-label">Name</span>
              </div>
              <div class="col-sm-12 mb-0">
                <input
                  formControlName="name"
                  type="text" size="10"
                  class="form-control bg-transparent border-0"
                  readonly
                />
              </div>
            </div>
            <div class="row text-start">
              <div class="col-sm-12 mb-0">
                <span class="form-label">Role</span>
              </div>
              <div class="col-sm-12 mb-0">
                <input
                  type="text"
                  class="form-control bg-transparent border-0"
                  formControlName="roleName"
                  readonly
                />
              </div>
            </div>
            <div class="row text-start" *ngIf="userData.clientAccountName">
              <div class="col-sm-12 mb-0">
                <span class="form-label">MAT Account Name</span>
              </div>
              <div class="col-sm-12 mb-0">
                <input
                  type="text"
                  class="form-control bg-transparent border-0"
                  formControlName="clientAccountName"
                  readonly
                />
              </div>
            </div>
            <div class="row text-start">
              <div class="col-sm-12 mb-0">
                <span class="form-label">Email Address</span>
              </div>
              <div class="col-sm-12 mb-0">
                <input
                  type="text"
                  class="form-control bg-transparent border-0"
                  formControlName="email"
                  readonly
                />
              </div>
            </div>
          </form>
        </div>
          </div>
         <div class="row">
            <div class="col-md-12">
            <fieldset class="theme-sample" style="padding: 1em;">
              <legend class="form-label">Theme</legend>
              
              <div class="row">
                <div class="col col-md-12">
                  Hover on the theme cards for a preview, and click to save your preference.
                </div>
              </div>
              <div class="row">
                <div class="col col-md-3">
                  <div  class="deesha-theme theme-sample" (click)="saveThemePreference('deesha')">
                    <mat-icon *ngIf="currentTheme=='deesha'" class="active-theme">check_circle</mat-icon>
                    Deesha
                  </div>
                </div>
                <div class="col col-md-3">
                    <div class="tealgreen-theme theme-sample" (click)="saveThemePreference('tealgreen')">
                      <mat-icon *ngIf="currentTheme=='tealgreen'" class="active-theme">check_circle</mat-icon>
                      Teal Green
                    </div>
                  </div>
               

                <div class="col col-md-3">
                  <div class="dark-theme theme-sample" (click)="saveThemePreference('dark')">
                    <mat-icon *ngIf="currentTheme=='dark'" class="active-theme">check_circle</mat-icon>
                    Dark</div>
                </div>
                
                  <div class="col col-md-3">
                    <div class="darkblue-theme theme-sample" (click)="saveThemePreference('darkblue')" >
                      <mat-icon *ngIf="currentTheme=='darkblue'" class="active-theme">check_circle</mat-icon>
                      Dark Blue</div>
                  </div>
                
                 
              </div>
              <div class="row">
                <div class="col col-md-3">
                  <div class="plum-theme theme-sample" (click)="saveThemePreference('plum')">
                    <mat-icon *ngIf="currentTheme=='plum'" class="active-theme">check_circle</mat-icon>
                    Plum</div>
                </div>
                
                  <div class="col col-md-3">
                  <div class="schoolred-theme theme-sample" (click)="saveThemePreference('schoolred')">
                    <mat-icon *ngIf="currentTheme=='schoolred'" class="active-theme">check_circle</mat-icon>
                    Red</div>
                </div>
                <div class="col col-md-3">
                  <div class="blue-theme theme-sample" (click)="saveThemePreference('blue')" >
                    <mat-icon *ngIf="currentTheme=='blue'" class="active-theme">check_circle</mat-icon>
                    Slate Blue</div></div>
                  
                  <div class="col col-md-3">
                    <div class="spaceblue-theme theme-sample" (click)="saveThemePreference('spaceblue')" >
                      <mat-icon *ngIf="currentTheme=='spaceblue'" class="active-theme">check_circle</mat-icon>
                      Space Blue</div>
                  </div>
              </div>
            </fieldset>
          </div>
          </div>
        
        </div>
        <div class="grid-item px-10" >
          <div class="row">
            <div class="col-md-12">
          <button type="button" class="btn theme-btn-outline change-password-btn-outline" (click)="editProfileModal()">
            Change Password
          </button>
</div>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</section>
